import { useUnit } from 'effector-react';
import { type FC } from 'react';
import { Pagination, ScrollArea, Stack } from '@mantine/core';
import { type PayinTrader, type PayinTraderFilters, usePayinTradersList } from '~/entities/payin';
import { type PaginationModel } from '~/shared/lib/pagination';
import { Table } from '~/shared/ui/Table';
import { createTableData } from '../utils';

interface TradersListProps {
    filter: PayinTraderFilters;
    polling?: boolean;
    onClick?: (trader: PayinTrader) => void;
    paginationModel: PaginationModel;
}

export const TradersList: FC<TradersListProps> = ({ filter, onClick, paginationModel, polling = false }) => {
    const pagination = useUnit(paginationModel.$pagination);

    const traders = usePayinTradersList(
        {
            'filter.statuses': filter.statuses,
            // 'filter.workingStatuses':
            //     filter.workingStatuses as unknown as AdminPayinTraderServiceListTradersFilterWorkingStatusesItem[],
            'pagination.page': pagination.page.toString(),
            'pagination.perPage': pagination.perPage.toString(),
            'filter.traderName.value': filter.traderName?.value,
        },
        polling ? 5000 : false,
    );

    const total = Number(traders.data?.page?.total);
    const totalPages = Math.ceil(total / pagination.perPage);

    const tableData = createTableData({
        traders: traders.data?.items,
    });

    const handleRowClick = (item: PayinTrader) => {
        return onClick?.(item);
    };

    const handleChangeCurrentPage = (page: number) => {
        paginationModel.setPage(page - 1);
    };

    return (
        <Stack>
            <ScrollArea h={512}>
                <Table
                    striped
                    highlightOnHover
                    data={tableData}
                    onRowClick={handleRowClick}
                    loading={traders.isLoading}
                />
            </ScrollArea>

            {totalPages > 1 && (
                <Pagination
                    total={totalPages}
                    value={pagination.page + 1}
                    onChange={handleChangeCurrentPage}
                    size='sm'
                />
            )}
        </Stack>
    );
};
